/**
 * calculate the duration of the scroll animation based on the width of the banner and text
 */
export function updateScrollAnimation() {
    var banner = document.querySelector('.scroll-banner');
    var text = document.querySelector('.scroll-text');
  
    if(banner && text) {
        var bannerWidth = banner.offsetWidth;
        var textWidth = text.offsetWidth;
    
        var endPosition = -(textWidth + bannerWidth);
    
        text.style.animation = "scrollText 30s linear infinite";
        text.style.transform = "translateX(" + bannerWidth + "px)";
    
        var style = document.createElement('style');
        style.innerHTML = "@keyframes scrollText { from { transform: translateX(" + bannerWidth / 10 + "px); } to { transform: translateX(" + endPosition + "px); } }";
        document.head.appendChild(style);
    }
}

window.addEventListener('load', updateScrollAnimation);
window.addEventListener('resize', updateScrollAnimation);



/** WEBPACK FOOTER **
 ** ./components/site-wide-banner.js
 **/